import * as React from "react";
import { connect } from "react-redux";
import { selectResourceAmountInfo } from "../../../balancingSelectors/selectBalancingResources";
import { IdTooltipAdjust } from "../../../constants/IdTooltipAdjust";
import { IdStyles } from "../../../less/IdStyles";
import { selectPendingInventoryTransferIdByTypeId } from "../../../selectors/selectPendingInventoryInfo";
import { selectTraderEventTradeDetails } from "../../../selectors/selectTraderEventInfo";
import { IdLoca } from "../../../utils/i18n/IdLoca";
import { PendingInventoryType } from "../../../utils/network/generated/protoTypes";
import { ButtonPrimaryMedium } from "../../generic/common/ButtonPrimaryMedium";
import { Icon } from "../../generic/icon/Icon";
import { IdIcon } from "../../generic/icon/IdIcon";
import { ResourceIcon } from "../../generic/icon/ResourceIcon";
import { NumberFormat } from "../../generic/number-format/NumberFormat";
import { ProgressBar } from "../../generic/progress-bar/ProgressBar";
import { TextLoca } from "../../generic/text/TextLoca";
import { TextLocaValueProportional } from "../../generic/text/TextLocaValueProportional";
import { actionPendingInventoryCollectRewards } from "../../pending-inventory/actionPendingInventoryInfo";
export var _TraderEventReward = function (_a) {
    var onClaimReward = _a.onClaimReward, traderEventDetails = _a.traderEventDetails, traderEventPendingInventoryTransferId = _a.traderEventPendingInventoryTransferId;
    if (traderEventDetails == undefined) {
        return React.createElement(React.Fragment, null);
    }
    var tradeResource = selectResourceAmountInfo(traderEventDetails.reward.typeId || 0, traderEventDetails.reward.amount || 0);
    var totalTraderItems = traderEventDetails.traderEventPackages.length;
    var boughtTraderItems = traderEventDetails.traderEventPackages.reduce(function (acc, traderItem) {
        return traderItem.isPurchased ? acc + 1 : acc;
    }, 0);
    var progressPercent = Math.round((boughtTraderItems / totalTraderItems) * 100);
    var getTraderRewardClaim = function () {
        if (traderEventPendingInventoryTransferId) {
            return (React.createElement(ButtonPrimaryMedium, { onClick: function () { return onClaimReward(traderEventPendingInventoryTransferId); } },
                React.createElement("div", { className: "flex flex--stacked flex--guts" },
                    React.createElement("div", { className: "" + IdStyles.TextBoldPrimary },
                        React.createElement(TextLoca, { className: IdStyles.TextButtonDefault, id: IdLoca.collect })))));
        }
        else {
            return (React.createElement("div", null,
                React.createElement(Icon, { icon: IdIcon.CheckIcn, styleId: IdStyles.IconExtraLarge })));
        }
    };
    var getTraderRewardProgress = function () {
        if (boughtTraderItems === totalTraderItems) {
            return getTraderRewardClaim();
        }
        else {
            return (React.createElement(ProgressBar, { backgroundClassName: IdStyles.ProgressBarIncompleteBackground, fillClassName: IdStyles.ProgressBarFill, progressPercent: progressPercent },
                React.createElement(TextLocaValueProportional, { className: IdStyles.TextNormal, available: boughtTraderItems, required: totalTraderItems })));
        }
    };
    return (React.createElement("div", { className: IdStyles.TraderRewardContainer + " trader-event__reward flex flex--aligned flex--evenly flex--stacked" },
        React.createElement(TextLoca, { id: IdLoca.traderEvent_finalReward_desc, className: IdStyles.TextBoldPrimary }),
        React.createElement("div", { className: IdStyles.TraderEventRewardImageBackground + " flex flex--guts flex--stacked" },
            React.createElement(ResourceIcon, { resource: tradeResource, styleId: IdStyles.IconExtraLarge, tooltipVerticalAdjust: -IdTooltipAdjust.Small }),
            React.createElement(NumberFormat, { className: IdStyles.TextNormal, amount: tradeResource.amount })),
        getTraderRewardProgress()));
};
var mapState = function (state) { return ({
    traderEventDetails: selectTraderEventTradeDetails(state),
    traderEventPendingInventoryTransferId: selectPendingInventoryTransferIdByTypeId(state, PendingInventoryType.TRADER_EVEENT_FULFILLED),
}); };
var mapDispatch = function (dispatch) { return ({
    onClaimReward: function (transferId) { return dispatch(actionPendingInventoryCollectRewards(transferId)); },
}); };
export var TraderEventReward = connect(mapState, mapDispatch)(_TraderEventReward);



//////////////////
// WEBPACK FOOTER
// ./src/features/trader-event/components/TraderEventReward.tsx
// module id = 2960
// module chunks = 3